import React, { useState } from "react";
import PersonalInformation from "./PersonalInformation";
import ChangePassword from "./ChangePassword";
import profile from "../../assets/profile.png";
import edit from "../../assets/edit.png";
import ChangePin from "./ChangePin";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("personal");

  const handlePersonalInfoClick = () => {
    setActiveTab("personal");
  };

  const handleChangePasswordClick = () => {
    setActiveTab("password");
  };

  const handleChangePinClick = () => {
    setActiveTab("pin");
  };

  return (
    <>
      <section className="settings">
        <div className="card">
          <div className="card-body">
            <div className="button-wrapper">
              <button
                className={activeTab === "personal" ? "btn" : "btn active"}
                onClick={handlePersonalInfoClick}
              >
                Personal Information
              </button>
              <button
                className={activeTab === "password" ? "btn" : "btn active"}
                onClick={handleChangePasswordClick}
              >
                Change Password
              </button>
              <button
                className={activeTab === "pin" ? "btn" : "btn active"}
                onClick={handleChangePinClick}
              >
                Change Pin
              </button>
            </div>
            <div className="profile-wrapper">
              {activeTab === "personal" && <PersonalInformation />}
              {activeTab === "password" && <ChangePassword />}
              {activeTab === "pin" && <ChangePin />}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Settings;